import { render, staticRenderFns } from "./UpgradeSubscriptionPage.vue?vue&type=template&id=207ae006&scoped=true&"
import script from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeSubscriptionPage.vue?vue&type=style&index=0&id=207ae006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207ae006",
  null
  
)

export default component.exports